import { Component, Input, Inject, Output, EventEmitter, ViewChild } from '@angular/core';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenDocumentController } from '@shared/src/controllers/open/open.document.controller';
import { DocumentViewerTypeDto } from '@shared/src/dtos/document/struct/DocumentViewerTypeDto';
import { DocumentParentObjectDto } from '@shared/src/dtos/documentaryreview/DocumentParentObjectDto';
import { RoutePartCMRBaseDto } from '@shared/src/dtos/route/cmr/RoutePartCMRBaseDto';
import { DocumentParentTypes } from '@shared/src/enums/DocumentParentTypes';
import { SharedRoutePartCMRDigitalDocumentComponent } from '../digitaldocument/shared.route.part.cmr.digitaldocument.component';

@Component({
  selector: 'shared-route-part-cmr-document-component',
  templateUrl: './shared.route.part.cmr.document.component.html',
  styleUrls: ['./shared.route.part.cmr.document.component.scss'],
})
export class SharedRoutePartCMRDocumentComponent {

  @ViewChild(SharedRoutePartCMRDigitalDocumentComponent) digitalDocument: SharedRoutePartCMRDigitalDocumentComponent;

  public useIonic: boolean = false;

  constructor(@Inject('HomeController') public homeController: HomeController,
  public openDocumentController: OpenDocumentController) {

    if (homeController.useIonic)
      this.useIonic = homeController.useIonic();
  }
  
  @Input() public readonly: boolean = false;
  
  @Input() public external: boolean = false;

  public parentObject: DocumentParentObjectDto;
  public __value: RoutePartCMRBaseDto;
  @Input()
  set value(value: RoutePartCMRBaseDto) {
    if (this.__value === value)
      return;
    this.__value = value;
    this.loadParentObject();
  }
  get value(): RoutePartCMRBaseDto {
    return this.__value;
  }
    
  @Input()
  public avoidOptionFirma: boolean = false;

  public documents: Array<DocumentViewerTypeDto>;

  loadParentObject(){
    this.parentObject = this.value != null ? DocumentParentObjectDto.build(DocumentParentTypes.RoutePartCMR, 0, 0, 0, this.value.routePartCMRId, 0) : null;
    this.loadDocuments();
  }

  loadDocuments(){
    if(this.parentObject == null)
      this.documents = null;
    else{
        this.openDocumentController.getAllDocumentsByParentObject(this.parentObject).subscribe(data => {
          this.documents = data;
      });
    }
  }

  @Output() dataRefresh: EventEmitter<boolean> = new EventEmitter();
  public onDataRefresh(value: boolean) {
    this.loadDocuments();
    if (this.digitalDocument)
      this.digitalDocument.reload();
    this.dataRefresh.next(value);
  }

  ngOnInit() {

  }

}
